import { useDocumentMeta } from "@/lib/document-meta";
import { MarketingSections } from "./components/MarketingSections";
import { SiteLayout } from "./SiteLayout";

export function MarketingPage() {
  useDocumentMeta({
    title: "SYLVIQ — one account for your whole back office",
    description:
      "Accounting, inventory, CRM and more on one SYLVIQ account. Accounting is live today; other apps are in development.",
    path: "/",
  });
  return (
    <SiteLayout>
      <MarketingSections />
    </SiteLayout>
  );
}
